import { Outlet } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import Stack from '@mui/material/Stack';

import {
  AppBar,
  AppDrawer,
  Footline,
  MobileBottomNavigation,
  RequestErrorSnackbar,
} from '@/components/common';

import { useBreakpoints } from '@/hooks';

import { appStore, retryAllAfterRequestErrors } from '@/store';

function Layout() {
  const snap = useSnapshot(appStore);
  const { isMobileDevice } = useBreakpoints();

  return (
    <>
      {/* App bar with logo & all */}
      <AppBar />
      {/* Request errors notifications */}
      <RequestErrorSnackbar
        errors={snap.requestErrors}
        onRetry={retryAllAfterRequestErrors}
      />
      {/* Disable app drawer on mobile as (we use MobileBottomNavigation instead) */}
      {!isMobileDevice && <AppDrawer />}
      {/* Page content */}
      <Stack
        direction="row"
        alignItems="stretch"
        flexGrow={1}
        sx={{
          backgroundColor: '#f8f8f8',
          width: '100%',
          height: '100%',
        }}
      >
        <Outlet />
      </Stack>
      {!isMobileDevice && <Footline />}
      {/* add bottom navigation component on mobile */}
      {isMobileDevice && <MobileBottomNavigation />}
    </>
  );
}

export { Layout };
